<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              알림함
            </div>
          </section>
          <section class="section02">
            <!-- 알림 없을때(Class) : none -->
            <div class="object01" :class="alarmList !== null && !alarmList.length ? 'none' : ''">
              <div class="item" v-for="alarm in alarmList" :key="alarm.alarm_id" @click="moveMenu(`/${alarm.landingId.replace(/-/g,'')}`)">
                <div class="item01">
                  <div class="title">
                    <div class="caption">
                      {{ alarm.title }}
                    </div>
                    <div class="date">
                      {{ agoDate(alarm.insert_dt) }}
                    </div>
                  </div>
                  <div class="content">
                    {{ alarm.message }}
                  </div>
                </div>
                <div class="item02">
                  <div class="more">
                    자세히 보기
                  </div>
                </div>
              </div>
              <div class="none">
                수신된 알림이 없습니다.
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <!-- 확인만(Class) : typeConfirm -->
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    답변을 등록하면 문의자에게<br />
                    알림이 발송됩니다.<br />
                    이대로 등록하시겠습니까?
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from './layout/Left.vue'
import HeaderLayout from './layout/Header.vue'
import FooterLayout from './layout/Footer.vue'
import {settingService, userService} from '../router'
import moment from 'moment'

export default {
  name: 'AL001',
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  data () {
    return {
      alarmList: null
    }
  },
  created: function () {
    moment.locale('ko')
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
  },
  mounted: function () {
    this.setData()
  },
  methods: {
    setData: function () {
      settingService.getPushAlarmList(1, 5).then(response => {
        this.alarmList = response.alarmList || []
      }).catch(error => {
        console.log('getAlarmList.err.===>', error)
      })
    },
    agoDate: function (date) {
      let now = moment()
      let isrtDt = moment(date)
      if (now.diff(isrtDt, 'hours') < 24) return isrtDt.fromNow()
      return isrtDt.format('YYYY-MM-DD')
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AL001.vue